import { Component, OnInit } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
interface Tasks {
  id: Number;
  name: String;
  description: String;
  subId1desc1: String;
  subId1desc2: string;
  subId1desc3: string;
  subId1desc4: string;
  subId1desc5: string;
  subId1desc6: string;

}
@Component({
  selector: 'app-faq-support',
  templateUrl: './faq-support.component.html',

})
export class FaqSupportComponent implements OnInit {


  tasksData: Tasks[] = [];
  tabsData: any = [];

  selectedI: number = 0
  items: any;
  selectedIn: any;
  searchText: any
  constructor(private http: HttpClient, private translateService: TranslateService) {

    let faqdata = [];
    let tabsdata = [];
    translateService.get(["HELPFAQ"]).subscribe(
      values => {
        faqdata = Object.keys(values).map(key => values[key]);
        this.tasksData = faqdata[0].FAQ_QUESTIONS;
      }
    );
    translateService.get(["HELPFAQ"]).subscribe(
      values => {
        tabsdata = Object.keys(values).map(key => values[key]);
        this.tabsData = tabsdata[0].TABSDATA;
      }
    );

  }

  ngOnInit(): void {
    this.selectedI = 0;
  }


  selectedIndex(i: any, data: any) {
    this.searchText = null;
    this.selectedI = i;
    this.selectedIn = null;
  }


  accBtnClicked(i: any) {
    this.tasksData.forEach((ele) => {
      if (ele.id == i) {
        this.selectedIn = i;
      }
    })

  }


}
